<form *ngIf="form"
      [formGroup]="form">
    <div class="timepicker-group">
        <mat-form-field *ngLet="form.get('days') as days">
            <input [placeholder]="daysPlaceholder"
                   [errorStateMatcher]="daysErrorStateMatcher"
                   [attr.min]="daysRange.min"
                   [attr.max]="daysRange.max"
                   [attr.data-cy]="'queue-'+ ngControl.name! +'-days-picker'"
                   formControlName="days"
                   matInput
                   uiRestrictInput="^[0-9]+$"
                   type="number"
                   autocomplete="off" />
            <mat-error *ngIf="errorToDisplay">
                {{errorToDisplay!.errorMessage}}
            </mat-error>
            <mat-error *ngIf="!errorToDisplay && days.hasError('range')"
                       [translateParams]="{
                              min: days.getError('range').min,
                              max: days.getError('range').max
                           }"
                       translate>
                input_number_range_warning
            </mat-error>
        </mat-form-field>

        <mat-form-field *ngLet="form.get('hours') as hours"
                        class="timepicker">
            <input [placeholder]="hoursPlaceholder"
                   [errorStateMatcher]="hoursErrorStateMatcher"
                   [attr.min]="hoursRange.min"
                   [attr.max]="hoursRange.max"
                   [attr.data-cy]="'queue-'+ ngControl.name! +'-hours-picker'"
                   formControlName="hours"
                   matInput
                   uiRestrictInput="^[0-9]+$"
                   type="number"
                   autocomplete="off" />
            <mat-error *ngIf="hours.hasError('range')"
                       [translateParams]="{
                           min: hours.getError('range').min,
                           max: hours.getError('range').max
                       }"
                       translate>
                input_number_range_warning
            </mat-error>
        </mat-form-field>
    </div>
</form>
